<ng-template class="theme-modal" #ordersModal let-modal>
  <div class="modal-content quick-view-modal">
    <div class="modal-body">
      <button
        type="button"
        class="close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="orders overflow-auto">
        <div class="ordersheader">Order No: {{ orderId }}</div>
        <div class="orderlist">
          <div class="itembox" *ngFor="let orderitem of orderitems;let i = index">
            <div class="pr-4">{{ i+1 }}</div>
            <div class="img-div">
              <img [src]="orderitem?.itemImage" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">{{ orderitem?.itemName }}</span><br />
                  <span class="itemgrams">{{ orderitem?.uom}} - {{ orderitem?.itemPrice | currency: 'INR' : 'symbol' : '2.0-2'}}</span>
                </div>

                <div class="col-2">
                  <span class="itemgrams">Qty:{{ orderitem?.quantity }}</span>
                </div>
                <div class="col-2 text-right">Loc:{{ orderitem?.itemLoc }}</div>
                <div class="col-3 text-right">
                  <span class="itemPrice font-weight-bold">{{ orderitem?.totalPrice | currency: 'INR' : 'symbol' : '2.0-2'}}</span>
                </div>
              </div>
            </div>
          </div>
          
        </div>
        <div class="ordersfooter">
          <div class="row">
            <div class="col-md-6 footer-price">Total Items: {{ totalItems }}</div>
            <div class="col-md-6 text-right">Total Price: {{ totalPrice }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
